export type DomainDropDownOption = {
  text?: string;
  name?: string;
  value?: string;
};

/** The label a "Select Domain" dropdown actually renders for an option. */
export const domainOptionLabel = (option?: DomainDropDownOption | null): string =>
  String(option?.text ?? option?.name ?? option?.value ?? '').trim();

/**
 * Alphabetically order the options shown in a "Select Domain" dropdown, so a long
 * domain list is scannable instead of arriving in raw API order.
 *
 * Display-only by design. Callers pass the already-deduped list and resolve the
 * pre-selected domain from the unsorted source, so ordering here cannot change
 * which domain a modal defaults to, nor which duplicate survives dedupe.
 *
 * Matches the ordering the Organic Content / Page Drafts list filters already use
 * (see buildDomainFilterOptions in services/crListClientFilter).
 */
export const sortDomainOptions = <T extends DomainDropDownOption>(options?: T[] | null): T[] => {
  if (!Array.isArray(options)) {
    return [];
  }
  return [...options].sort((left, right) =>
    domainOptionLabel(left).localeCompare(domainOptionLabel(right), undefined, {
      sensitivity: 'base',
      numeric: true,
    })
  );
};
